import {
  Component,
  OnInit,
  ChangeDetectorRef,
} from '@angular/core';


import { InventoryCountService } from '../services/product-inventory-counts.service';
import { InventoryCount } from '../models/product-inventory-count.model';

import { List } from 'immutable';

import { Platform } from '@ionic/angular';

interface primeNgCol {
  field: string;
  header: string;
}

interface IRow {
  ID: number;
  dateTime: Date;
  countType: string;
  statusName: string;
  itemName: string;
}

@Component({
  selector: 'smr-inventory-count',
  templateUrl: './inventory-count.page.html',
  styleUrls: ['./inventory-count.page.scss'],
})
export class InventoryCountPage implements OnInit {
  public isLoading: boolean = true;
  public countItems: List<InventoryCount>;
  public stats: Array<IRow>;

  public rawData: Array<IRow>;
  public cols: primeNgCol[];

  public isMobile: boolean = false;

  constructor(
    private inventoryCountService: InventoryCountService,
    private changeDetectorRef: ChangeDetectorRef,
    private platform: Platform
  ) {
    this.isLoading = true;
    this.countItems = List([]);
    this.stats = [];
    this.cols = [
      { field: 'itemName', header: 'Name' },
      { field: 'dateTime', header: 'Date' },
      { field: 'isFullCount', header: 'Type' },
      { field: 'statusID', header: 'Status' },
    ];
  }


  public ionViewWillEnter() {
    this.stats = [];
    this.loadItems();
  }

  public ngOnInit() {
    this.platform.ready().then(() => {
      if(this.platform.is('mobile') || this.platform.is('android') || this.platform.is('iphone') || this.platform.is('mobileweb')) {
        this.isMobile = true;
      } 
    });
  }

  public loadItems() {
    this.isLoading = true;
    this.countItems = List([]);

    this.inventoryCountService.loadInventoryCounts().subscribe(
      (countItems) => {
        this.isLoading = false;
        this.countItems = countItems;
        this.mapPaginatorValue();
        this.changeDetectorRef.markForCheck();
      },
      (err) => {
        this.isLoading = false;
        this.changeDetectorRef.markForCheck();
      }
    );
  }

  public mapPaginatorValue() {
    this.countItems.forEach((countItem) => {
      let ID = countItem.getID();
      let dateTime = new Date(countItem.getDateTime());
      let itemName = countItem.getName();
      let isFullCount = countItem.getFullCountID();
      let countType = isFullCount == 1 ? 'Full' : 'Partial';
      let statusID = countItem.getStatusID();
      let statusName = statusID == 1 ? 'Completed' : 'Paused';
      this.stats.push({ ID, dateTime, countType, itemName, statusName });
      this.stats = this.stats.sort((a, b) => {
        return new Date(a.dateTime) < new Date(b.dateTime) ? 1 : -1;
      });

      this.rawData = this.stats;
    });
  }

  search(event) {
    const keyword = event.target.value.toLowerCase();
    this.stats = this.rawData.filter((stat) => {
      return (
        stat.itemName.toLowerCase().includes(keyword) ||
        stat.statusName.toLowerCase().includes(keyword) ||
        stat.countType.toLowerCase().includes(keyword)
      );
    });
  }
}
